import WidgetHeader from './widget-header';
import WidgetFooter from './widget-footer';
import WidgetContent from './widget-content';
import WidgetTitle from './widget-title';
import WidgetButtons from './widget-buttons';
import WidgetButton from './widget-button';
import WidgetHeaderPanel from './widget-header-panel';
import Widget from './widget';

type WidgetType = typeof Widget & {
  Header: typeof WidgetHeader;
  Footer: typeof WidgetFooter;
  Content: typeof WidgetContent;
  Title: typeof WidgetTitle;
  Buttons: typeof WidgetButtons;
  Button: typeof WidgetButton;
  HeaderPanel: typeof WidgetHeaderPanel;
};

const ComposedWidget = Widget as WidgetType;

ComposedWidget.Header = WidgetHeader;
ComposedWidget.Footer = WidgetFooter;
ComposedWidget.Content = WidgetContent;
ComposedWidget.Title = WidgetTitle;
ComposedWidget.Buttons = WidgetButtons;
ComposedWidget.Button = WidgetButton;
ComposedWidget.HeaderPanel = WidgetHeaderPanel;

export { ComposedWidget as Widget };
